import { makeAutoObservable, runInAction } from 'mobx';

import { cmApi } from '@src/api';
import type { CmApi, TableComponentRequestDto } from '@src/api';

import { preloaderStore } from '../../preloaderStore';

class RoundTypeStore {
  roundTypes: { id: string; name: string }[] = [];

  api: CmApi;

  constructor({ api }: { api: CmApi }) {
    this.api = api;
    makeAutoObservable(this);
  }

  fetch = async (): Promise<void> => {
    preloaderStore.preloader(true);
    try {
      const response = await cmApi.tableComponentV2.getTableJson({
        fields: ['rounding_type', 'rounding_type_desc'],
        hardFilter: [],
        limit: 10000,
        offset: 0,
        resource: 'ctrl.nsi_round_type',
      } as unknown as TableComponentRequestDto);

      const result = response?.data as unknown as { data: { rounding_type: string; rounding_type_desc: string }[] };

      if (result) {
        runInAction(() => {
          this.roundTypes = result.data.map((item) => ({
            id: item.rounding_type,
            name: `${item.rounding_type} - ${item.rounding_type_desc}`,
          }));
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      preloaderStore.preloader(false);
    }
  };
}

export const roundTypeStore = new RoundTypeStore({ api: cmApi });
